import React from "react"
import { Typography, styled } from "@mui/material"

type Props = {
  children: React.ReactNode
}

const TitleComponent = ({ children }: Props) => {
  return <Title variant="h3">{children}</Title>
}

export default TitleComponent

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
    lineHeight: "32px",
  },
}))
